(() => {
  const tabTriggerSelector = '[data-toggle="tab"], [data-bs-toggle="tab"]';

  const getTabPanel = (trigger) => {
    const rawTarget = trigger.getAttribute('data-target') || trigger.getAttribute('href') || '';
    let targetId = '';

    if (rawTarget.startsWith('#')) {
      targetId = rawTarget.slice(1);
    } else if (rawTarget) {
      try {
        targetId = new URL(rawTarget, window.location.href).hash.replace(/^#/, '');
      } catch (error) {
        targetId = '';
      }
    }

    const targetFromHref = /^[A-Za-z][\w:-]*$/.test(targetId)
      ? document.getElementById(targetId)
      : null;
    if (targetFromHref) {
      return targetFromHref;
    }

    const controlledId = trigger.getAttribute('aria-controls') || '';
    return /^[A-Za-z][\w:-]*$/.test(controlledId)
      ? document.getElementById(controlledId)
      : null;
  };

  const activateTab = (trigger) => {
    const panel = getTabPanel(trigger);
    const navigation = trigger.closest('.nav-tabs');
    const content = panel ? panel.closest('.tab-content') : null;

    if (!panel || !navigation || !content) {
      return false;
    }

    navigation.querySelectorAll(tabTriggerSelector).forEach((item) => {
      item.classList.toggle('active', item === trigger);
      item.setAttribute('aria-selected', item === trigger ? 'true' : 'false');
    });

    Array.from(content.children).forEach((item) => {
      const isPanel = item.classList.contains('tab-pane') || item.getAttribute('role') === 'tabpanel';
      if (isPanel) {
        const isActive = item === panel;
        item.classList.remove('active', 'show');
        item.style.display = isActive ? 'block' : 'none';
        if (isActive) {
          item.classList.add('active', 'show');
        }
      }
    });

    return true;
  };

  document.addEventListener('click', (event) => {
    const clicked = event.target instanceof Element ? event.target : event.target.parentElement;
    const trigger = clicked && clicked.closest(tabTriggerSelector);

    if (!trigger || !activateTab(trigger)) {
      return;
    }

    if (trigger.hasAttribute('onclick')) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
})();

(function ($) {
  if (!$) {
    return;
  }

  const MODAL_SHOW_CLASS = 'show';
  const MODAL_OPEN_CLASS = 'modal-open';
  const BACKDROP_SELECTOR = '.modal-backdrop';
  const COLLAPSE_DURATION = 300;
  const TAB_TRIGGER_SELECTOR = '[data-toggle="tab"], [data-bs-toggle="tab"]';

  const removeBackdrop = () => {
    $(BACKDROP_SELECTOR).remove();
  };

  const openModal = ($modal) => {
    if (!$modal || !$modal.length) {
      return;
    }

    $('body').addClass(MODAL_OPEN_CLASS);
    if (!$(BACKDROP_SELECTOR).length) {
      $('<div class="modal-backdrop"></div>').appendTo(document.body);
    }

    $modal.show().attr('aria-hidden', 'false').addClass(MODAL_SHOW_CLASS);
  };

  const closeModal = ($modal) => {
    if (!$modal || !$modal.length) {
      removeBackdrop();
      $('body').removeClass(MODAL_OPEN_CLASS);
      return;
    }

    $modal.removeClass(MODAL_SHOW_CLASS).attr('aria-hidden', 'true').hide();
    removeBackdrop();
    $('body').removeClass(MODAL_OPEN_CLASS);
  };

  const getModalFromTrigger = (triggerElement) => {
    const rawTarget = $(triggerElement).attr('data-target') || $(triggerElement).attr('href');

    if (!rawTarget) {
      return $();
    }

    let targetId = '';

    if (rawTarget.startsWith('#')) {
      targetId = rawTarget.slice(1);
    } else {
      try {
        const parsedUrl = new URL(rawTarget, window.location.href);
        targetId = (parsedUrl.hash || '').replace(/^#/, '');
      } catch (error) {
        targetId = '';
      }
    }

    if (!/^[A-Za-z][\w:-]*$/.test(targetId)) {
      return $();
    }

    const modalElement = document.getElementById(targetId);
    if (!modalElement || !modalElement.classList.contains('modal')) {
      return $();
    }

    return $(modalElement);
  };

  const getCollapseTarget = (triggerElement) => {
    const rawTarget = $(triggerElement).attr('data-target') || $(triggerElement).attr('href');

    if (!rawTarget || !rawTarget.startsWith('#')) {
      return $();
    }

    const targetId = rawTarget.slice(1);
    if (!/^[A-Za-z][\w:-]*$/.test(targetId)) {
      return $();
    }

    const collapseElement = document.getElementById(targetId);
    if (!collapseElement || !collapseElement.classList.contains('collapse')) {
      return $();
    }

    return $(collapseElement);
  };

  const getTabTarget = (triggerElement) => {
    const $trigger = $(triggerElement);
    const rawTarget = $trigger.attr('data-target') || $trigger.attr('href');
    const controlledId = $trigger.attr('aria-controls');

    let targetId = '';

    if (rawTarget && rawTarget.startsWith('#')) {
      targetId = rawTarget.slice(1);
    } else if (rawTarget) {
      try {
        const parsedUrl = new URL(rawTarget, window.location.href);
        targetId = (parsedUrl.hash || '').replace(/^#/, '');
      } catch (error) {
        return $();
      }
    }

    if (/^[A-Za-z][\w:-]*$/.test(targetId)) {
      const tabPanel = document.getElementById(targetId);
      if (tabPanel) {
        return $(tabPanel);
      }
    }

    if (controlledId && /^[A-Za-z][\w:-]*$/.test(controlledId)) {
      const controlledPanel = document.getElementById(controlledId);
      if (controlledPanel) {
        return $(controlledPanel);
      }
    }

    return $();
  };

  const showTab = ($tab, $tabTrigger) => {
    if (!$tab || !$tab.length) {
      return;
    }

    $tabTrigger = $tabTrigger && $tabTrigger.length
      ? $tabTrigger
      : $(TAB_TRIGGER_SELECTOR).filter(function () {
        const $target = getTabTarget(this);
        return $target.length && $target[0] === $tab[0];
      }).first();

    if (!$tabTrigger.length) {
      return;
    }

    const $tabNavigation = $tabTrigger.closest('.nav-tabs');
    const $previousTrigger = $tabNavigation.find(`${TAB_TRIGGER_SELECTOR}.active`).first();
    const $tabContent = $tab.closest('.tab-content');
    const tabNavigation = $tabNavigation[0];
    const tabContent = $tabContent[0];
    const tabElement = $tab[0];
    const tabTrigger = $tabTrigger[0];

    if (!tabNavigation || !tabContent || !tabElement || !tabTrigger) {
      return;
    }

    tabNavigation.querySelectorAll(TAB_TRIGGER_SELECTOR).forEach((trigger) => {
      trigger.classList.remove('active');
      trigger.setAttribute('aria-selected', 'false');
    });

    Array.from(tabContent.children).filter((panel) => {
      return panel.classList.contains('tab-pane') || panel.getAttribute('role') === 'tabpanel';
    }).forEach((panel) => {
      panel.classList.remove('active', 'show');
      panel.style.display = 'none';
    });

    tabTrigger.classList.add('active');
    tabTrigger.setAttribute('aria-selected', 'true');
    tabElement.classList.add('active', 'show');
    tabElement.style.display = 'block';

    $tabTrigger.trigger({
      type: 'shown.bs.tab',
      relatedTarget: $previousTrigger[0] || null,
    });
  };

  $.fn.tab = function (action) {
    return this.each(function () {
      if (action === 'show') {
        showTab(getTabTarget(this), $(this));
      }
    });
  };

  const showCollapse = ($collapse) => {
    if (!$collapse || !$collapse.length) {
      return;
    }

    const parentSelector = $collapse.attr('data-parent');
    if (parentSelector && parentSelector.startsWith('#')) {
      const parentId = parentSelector.slice(1);
      if (/^[A-Za-z][\w:-]*$/.test(parentId)) {
        const parentElement = document.getElementById(parentId);
        if (parentElement) {
          $(parentElement).find('.collapse.show').not($collapse).each(function () {
            hideCollapse($(this));
          });
          const collapseId = $collapse.attr('id');
          $(parentElement).find('[data-toggle="collapse"]').each(function () {
            if ($(this).attr('data-target') !== '#' + collapseId) {
              $(this).addClass('collapsed').attr('aria-expanded', 'false');
            }
          });
        }
      }
    }

    const collapseElement = $collapse[0];
    collapseElement.style.display = 'block';
    collapseElement.style.overflow = 'hidden';
    collapseElement.style.height = '0px';
    collapseElement.style.transition = `height ${COLLAPSE_DURATION}ms ease`;
    $collapse.addClass('show');

    // Force layout so the browser can animate from 0 to the content height.
    collapseElement.offsetHeight;
    collapseElement.style.height = `${collapseElement.scrollHeight}px`;

    window.setTimeout(() => {
      if (!$collapse.hasClass('show')) {
        return;
      }

      collapseElement.style.height = 'auto';
      collapseElement.style.overflow = '';
      collapseElement.style.transition = '';
    }, COLLAPSE_DURATION);
  };

  const hideCollapse = ($collapse) => {
    if (!$collapse || !$collapse.length) {
      return;
    }

    const collapseElement = $collapse[0];
    collapseElement.style.display = 'block';
    collapseElement.style.overflow = 'hidden';
    collapseElement.style.height = `${collapseElement.offsetHeight}px`;
    collapseElement.style.transition = `height ${COLLAPSE_DURATION}ms ease`;

    // Force layout so the browser can animate from the current height to 0.
    collapseElement.offsetHeight;
    collapseElement.style.height = '0px';

    window.setTimeout(() => {
      $collapse.removeClass('show');
      collapseElement.style.display = 'none';
      collapseElement.style.height = '';
      collapseElement.style.overflow = '';
      collapseElement.style.transition = '';
    }, COLLAPSE_DURATION);
  };

  $.fn.collapse = function (action) {
    return this.each(function () {
      const $collapse = $(this);

      if (action === 'hide') {
        hideCollapse($collapse);
        return;
      }

      if (action === 'toggle') {
        if ($collapse.hasClass('show')) {
          hideCollapse($collapse);
        } else {
          showCollapse($collapse);
        }
        return;
      }

      showCollapse($collapse);
    });
  };

  $.fn.modal = function (action) {
    return this.each(function () {
      const $modal = $(this);

      if (action === 'hide') {
        closeModal($modal);
        return;
      }

      if (action === 'toggle') {
        if ($modal.hasClass(MODAL_SHOW_CLASS)) {
          closeModal($modal);
        } else {
          openModal($modal);
        }
        return;
      }

      openModal($modal);
    });
  };

  $(document).on('click', '[data-toggle="modal"]', function (e) {
    const $targetModal = getModalFromTrigger(this);
    if (!$targetModal.length) {
      return;
    }

    e.preventDefault();
    $targetModal.modal('show');
  });

  $(document).on('click', '[data-toggle="collapse"]', function (e) {
    const $targetCollapse = getCollapseTarget(this);
    if (!$targetCollapse.length) {
      return;
    }

    e.preventDefault();
    const isExpanded = $targetCollapse.hasClass('show');
    $targetCollapse.collapse(isExpanded ? 'hide' : 'show');
    $(this).toggleClass('collapsed', isExpanded).attr('aria-expanded', String(!isExpanded));
  });

  document.addEventListener('click', (e) => {
    const clickedElement = e.target instanceof Element ? e.target : e.target.parentElement;
    const triggerElement = clickedElement && clickedElement.closest(TAB_TRIGGER_SELECTOR);
    if (!triggerElement) {
      return;
    }

    const $targetTab = getTabTarget(triggerElement);
    if (!$targetTab.length) {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
    showTab($targetTab, $(triggerElement));
  });

  $(document).on('click', '[data-dismiss="modal"]', function (e) {
    e.preventDefault();
    closeModal($(this).closest('.modal'));
  });
})(window.jQuery);
